import { PALETTE } from '../../common/styles/palette';
export const styles = (theme: any) => {
    return {
        root: {
            paddingLeft: '20px'
        },
        selectedTrainer: {
            backgroundColor: PALETTE.Contacts.List.SelectedContact.BackGroundColor,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.SelectedContact.HoveredBackGroundColor
            },
        },
        trainer: {
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.HoveredBackGroundColor
            },
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        listSubheaderContainer: {
            backgroundColor: 'inherit',
            padding: 0,
        },
        listSubheader: {
            backgroundColor: "#ff6600",
            color: "white",
        },
        nameSurnameContainer: {
            paddingRight: 10
        },
        tagsContainer: {
            paddingLeft: '10px'
        },
        sectionHeader: {
            paddingLeft: '1px',
            fontWeight: "bold" as 'bold', 
            marginTop: '10px',
        },
    }
}